import React, { useState } from 'react';

export const ExpandableText = ({ text, maxLength = 1000 }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  if (!text) return null;

  const shouldTruncate = text.length > maxLength;
  const displayText = isExpanded || !shouldTruncate
    ? text
    : text.substring(0, maxLength) + '...';

  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div>
      <span style={{ whiteSpace: 'pre-wrap' }}>{displayText}</span>
      {shouldTruncate && (
        <div style={{ marginTop: '8px' }}>
          <button
            type="button"
            onClick={toggleExpanded}
            style={{
              background: 'none',
              border: 'none',
              color: '#878484',
              cursor: 'pointer',
              textDecoration: 'none',
              padding: 0,
              fontSize: '14px',
              fontWeight: '400'
            }}
          >
            {isExpanded ? 'Сховати' : 'Показати більше'}
          </button>
        </div>
      )}
    </div>
  );
};